export default "__VITE_ASSET__CNtH13i9__"